import React from 'react';
import scrollTo from 'gatsby-plugin-smoothscroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getSolidFontAwesomeIcon } from 'utils/font-awesome/solid';

import { scrollToTop } from './ScrollToTop.scss';

const ScrollToTop = (): JSX.Element => (
  <button type="button" className={scrollToTop} onClick={() => scrollTo('body')} aria-label="Scroll to top">
    <FontAwesomeIcon icon={getSolidFontAwesomeIcon('faCircleArrowUp')} />
  </button>
);

export default ScrollToTop;
